import { authQueries, defaultOptions, UseQueryOptionsObject } from '../queries';
import { brandClient, BrandResponse } from 'src/lib/services/api/brand-api';
import { useMakeQuery } from '../useMakeQuery';

const useBrandQuery = (brandId: string, options?: UseQueryOptionsObject<BrandResponse>) => {
  return useMakeQuery<
    BrandResponse,
    Pick<Partial<BrandResponse>, 'name' | 'description' | 'colors' | 'media'>
  >([authQueries.brand, brandId], () => brandClient.get(brandId), {
    staleTime: 60 * 1000,
    ...defaultOptions({
      auth: true,
      ...(options ?? {}),
    }),
  });
};

export { useBrandQuery };
